<template>
  <div @click="$emit('close')" class="zoom-wrapper">
    <div class="modal-wrapper">
        <div class="img-wr">
            <img  :src="src">
        <div class="close-button">
            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><line fill="none" stroke="#000" stroke-width="1.4" x1="1" y1="1" x2="19" y2="19"></line><line fill="none" stroke="#000" stroke-width="1.4" x1="19" y1="1" x2="1" y2="19"></line></svg>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
//import posed from "vue-pose";

const transition = {
  duration: 400,
  ease: [0.08, 0.69, 0.2, 0.99],
};

export default {
    name: 'ZoomImage',
    props: {
        src: String,
    },
    data: () => ({
        isZoomed: false,
    }),

  methods: {
    zoomIn() {
      window.addEventListener("scroll", this.zoomOut);
      this.isZoomed = true;
    },
    zoomOut() {
      window.removeEventListener("scroll", this.zoomOut);
      this.isZoomed = false;
    },
  },
  computed: {
    pose() {
      return this.isZoomed ? "zoomedIn" : "zoomedOut";
    },
    toggleZoom() {
      return this.isZoomed ? this.zoomOut : this.zoomIn;
    },
  },
//   components: {
//     Frame: posed.div({
//       zoomedOut: {
//         applyAtEnd: { display: "none" },
//         opacity: 0,
//       },
//       zoomedIn: {
//         applyAtStart: { display: "block" },
//         opacity: 1,
//       },
//     }),
//     ZoomImage: posed.img({
//       zoomedOut: {
//         position: "static",
//         width: "auto",
//         height: "auto",
//         flip: true,
//         transition,
//       },
//       zoomedIn: {
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         flip: true,
//         transition,
//       },
//     }),
//   },
};
</script>

<style>
img {
  
}

img.zoomed {
  cursor: zoom-out;
}

.frame {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  background: white;
  transform: translateZ(0);
}
</style>